(() => {
  if (window.foamberryReviewsReady) return;
  window.foamberryReviewsReady = true;
  const mounted = new WeakSet();
  function init(scope) {
    scope.querySelectorAll('[data-foamberry-reviews]').forEach(root => {
      if (mounted.has(root)) return;
      mounted.add(root);
      const list = root.querySelector('.splide__list');
      const counter = root.querySelector('[data-review-counter]');
      const progress = root.querySelector('[data-review-progress]');
      if (!list || !counter || !progress) return;
      const update = () => {
        const slides = [...list.children].filter(slide => !slide.classList.contains('splide__slide--clone'));
        const active = slides.find(slide => slide.classList.contains('is-active'));
        const index = Number(active?.dataset.reviewIndex || 1);
        counter.textContent = `${index} / ${slides.length}`;
        progress.style.width = `${index / slides.length * 100}%`;
      };
      const observer = new MutationObserver(update);
      observer.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
      root.addEventListener('foamberry:disconnect', () => observer.disconnect(), { once: true });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-foamberry-reviews]').forEach(root => root.dispatchEvent(new Event('foamberry:disconnect')));
  });
})();
